import { Box, alpha } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AssistantRelatedTopics = styled("section")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  paddingTop: theme.spacing(4),
  borderTop: `1px solid ${theme.palette.custom.semantic.border.subtle}`,
}));

export const AssistantRelatedTopic = styled("details")(({ theme }) => ({
  border: `1px solid ${theme.palette.custom.semantic.border.default}`,
  borderRadius: theme.shape.borderRadius[2],
  backgroundColor: theme.palette.custom.semantic.surface.card,
  "&[open] > summary": {
    backgroundColor: theme.palette.custom.semantic.surface.hover,
    borderBottom: `1px solid ${theme.palette.custom.semantic.border.subtle}`,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  "&[open] > summary > svg:last-child": {
    transform: "rotate(90deg)",
  },
}));

export const AssistantRelatedTopicSummary = styled("summary")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  padding: theme.spacing(3, 4),
  minHeight: theme.spacing(8),
  borderRadius: theme.shape.borderRadius[2],
  cursor: "pointer",
  listStyle: "none",
  color: theme.palette.primary.main,
  "&::-webkit-details-marker": { display: "none" },
  "&:hover": {
    backgroundColor: theme.palette.custom.semantic.surface.hover,
  },
  "&:focus-visible": {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: theme.spacing(1),
    backgroundColor: alpha(
      theme.palette.primary.main,
      theme.palette.action.focusOpacity
    ),
  },
  "& > svg": { flexShrink: 0 },
  "& > svg:last-child": { marginLeft: "auto" },
}));

export const AssistantRelatedTopicContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(4),
  padding: theme.spacing(4),
  "& > div": {
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      ...theme.typography.subtitle8,
    },
  },
}));
